import { createAction, props } from '@ngrx/store';
import { Device } from 'domain-entities';

export const setCurrentDevice = createAction(
	'[Device] set current device',
	props<{ device: Device }>(),
);
